import { render } from "./prod-template-edit.vue?vue&type=template&id=3680d398&scoped=true"
import script from "./prod-template-edit.vue?vue&type=script&lang=js"
export * from "./prod-template-edit.vue?vue&type=script&lang=js"

import "./prod-template-edit.vue?vue&type=style&index=0&id=3680d398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3680d398"]])

export default __exports__